(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexuskin-home-motion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.NexuskinHomeMotion?.refresh) {
      window.NexuskinHomeMotion.refresh();
      return;
    }

    const state = {
      observer: null,
      hero: null,
      sequences: [],
      introTimer: null,
      heroTimer: null,
      settleTimers: []
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileViewport = window.matchMedia('(max-width: 749px)');

    const getRoot = () => document.querySelector('[data-nx-motion-root]');

    const motionIsAllowed = () => {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return !reducedMotion.matches && !connection?.saveData;
    };

    const clearTimers = () => {
      if (state.introTimer) window.clearTimeout(state.introTimer);
      if (state.heroTimer) window.clearTimeout(state.heroTimer);
      state.settleTimers.forEach((timer) => window.clearTimeout(timer));
      state.introTimer = null;
      state.heroTimer = null;
      state.settleTimers = [];
    };

    const clearIntro = () => {
      document.documentElement.classList.remove('nx-intro-pending');
    };

    const revealSequence = (sequence) => {
      if (!sequence || sequence.classList.contains('is-nx-revealed')) return;
      sequence.classList.add('is-nx-revealed');
      if (state.observer) state.observer.unobserve(sequence);

      const timer = window.setTimeout(() => {
        sequence.classList.add('is-nx-settled');
      }, 2300);
      state.settleTimers.push(timer);
    };

    const revealAll = () => {
      state.sequences.forEach(revealSequence);
      if (state.hero) revealSequence(state.hero);
    };

    const removeMotionState = () => {
      if (state.observer) state.observer.disconnect();
      state.observer = null;
      document.documentElement.classList.remove('nx-motion-active', 'nx-motion-pending');
      document.querySelectorAll('[data-nx-reveal]').forEach((element) => {
        element.removeAttribute('data-nx-reveal');
        element.style.removeProperty('--nx-reveal-delay');
      });
      document.querySelectorAll('[data-nx-sequence]').forEach((element) => {
        element.removeAttribute('data-nx-sequence');
        element.classList.remove('is-nx-revealed', 'is-nx-settled');
      });
      state.hero = null;
      state.sequences = [];
    };

    const addSequence = (container, entries) => {
      if (!container) return null;

      container.setAttribute('data-nx-sequence', '');
      container.classList.remove('is-nx-revealed', 'is-nx-settled');

      entries.forEach(({ element, role, delay = 0 }) => {
        if (!element) return;
        element.setAttribute('data-nx-reveal', role);
        element.style.setProperty('--nx-reveal-delay', `${delay}ms`);
      });

      state.sequences.push(container);
      return container;
    };

    const prepareSequences = () => {
      const root = getRoot();
      if (!root) return;

      clearTimers();
      removeMotionState();

      const designMode = root.dataset.designMode === 'true' || window.Shopify?.designMode;
      const revealEnabled = root.dataset.enableScrollReveal === 'true';

      if (designMode || !motionIsAllowed() || !revealEnabled) return;

      document.documentElement.classList.add('nx-motion-active');
      document.documentElement.classList.remove('nx-motion-pending');

      const isMobile = mobileViewport.matches;

      const hero = document.querySelector('.nexuskin-hero');
      if (hero) {
        state.hero = addSequence(
          hero,
          [
            {
              element: hero.querySelector('.nexuskin-hero__media'),
              role: 'media',
              delay: 0
            },
            {
              element: hero.querySelector('.nexuskin-hero__eyebrow'),
              role: 'eyebrow',
              delay: isMobile ? 300 : 420
            },
            {
              element: hero.querySelector('.nexuskin-hero__heading'),
              role: 'heading',
              delay: isMobile ? 450 : 560
            },
            {
              element: hero.querySelector('.nexuskin-hero__text'),
              role: 'body',
              delay: isMobile ? 650 : 790
            },
            {
              element: hero.querySelector('.nexuskin-hero__actions'),
              role: 'action',
              delay: isMobile ? 850 : 1010
            }
          ]
        );
      }

      const collectionHeader = document.querySelector('.nx-collection__header');
      if (collectionHeader) {
        addSequence(collectionHeader, [
          {
            element: collectionHeader.querySelector('.nx-collection__eyebrow'),
            role: 'eyebrow',
            delay: isMobile ? 80 : 120
          },
          {
            element: collectionHeader.querySelector('h2'),
            role: 'heading',
            delay: isMobile ? 190 : 260
          },
          {
            element: collectionHeader.querySelector('.nx-collection__intro > p'),
            role: 'body',
            delay: isMobile ? 360 : 470
          },
          {
            element: collectionHeader.querySelector('.nx-collection__all'),
            role: 'action',
            delay: isMobile ? 520 : 680
          }
        ]);
      }

      document.querySelectorAll('.nx-product-card').forEach((card, index) => {
        const cardOffsets = [0, 140, 330];
        const cardOffset = isMobile ? 0 : cardOffsets[index % 3];
        addSequence(card, [
          {
            element: card.querySelector('.nx-product-card__media'),
            role: 'media',
            delay: cardOffset
          },
          {
            element: card.querySelector('.nx-product-card h3'),
            role: 'heading',
            delay: cardOffset + 360
          },
          {
            element: card.querySelector('.nx-product-card__descriptor'),
            role: 'body',
            delay: cardOffset + 570
          },
          {
            element: card.querySelector('.nx-product-card__price'),
            role: 'action',
            delay: cardOffset + 850
          }
        ]);
      });

      document.querySelectorAll('.ns-journey__chapter').forEach((chapter) => {
        const copy = chapter.querySelector('.ns-journey__copy');
        addSequence(chapter, [
          {
            element: chapter.querySelector('.ns-journey__media'),
            role: 'media',
            delay: 0
          },
          {
            element: copy?.querySelector('.ns-journey__eyebrow'),
            role: 'eyebrow',
            delay: isMobile ? 300 : 430
          },
          {
            element: copy?.querySelector('h2'),
            role: 'heading',
            delay: isMobile ? 420 : 580
          },
          {
            element: copy?.querySelector('p:not(.ns-journey__eyebrow):not(.ns-journey__quiet-proof)'),
            role: 'body',
            delay: isMobile ? 620 : 820
          },
          {
            element: copy?.querySelector('.ns-journey__link, .ns-journey__quiet-proof'),
            role: 'action',
            delay: isMobile ? 820 : 1030
          }
        ]);
      });

      const technology = document.querySelector('.ns-journey__technology');
      if (technology) {
        const proofItems = Array.from(technology.querySelectorAll('.ns-journey__technology-proof p'));
        addSequence(technology, [
          {
            element: technology.querySelector('.ns-journey__eyebrow'),
            role: 'eyebrow',
            delay: isMobile ? 100 : 140
          },
          {
            element: technology.querySelector('h2'),
            role: 'heading',
            delay: isMobile ? 220 : 300
          },
          {
            element: technology.querySelector('.ns-journey__technology-body'),
            role: 'body',
            delay: isMobile ? 410 : 550
          },
          {
            element: proofItems[0],
            role: 'body',
            delay: isMobile ? 610 : 780
          },
          {
            element: proofItems[1],
            role: 'body',
            delay: isMobile ? 750 : 920
          },
          {
            element: technology.querySelector('.ns-journey__link'),
            role: 'action',
            delay: isMobile ? 920 : 1120
          }
        ]);
      }

      const materials = document.querySelector('.ns-journey__materials');
      if (materials) {
        const materialItems = Array.from(materials.querySelectorAll('.ns-journey__material-notes > div'));
        addSequence(materials, [
          {
            element: materials.querySelector('.ns-journey__eyebrow'),
            role: 'eyebrow',
            delay: isMobile ? 80 : 120
          },
          {
            element: materials.querySelector('h2'),
            role: 'heading',
            delay: isMobile ? 190 : 260
          },
          {
            element: materials.querySelector('.ns-journey__materials-intro > p:not(.ns-journey__eyebrow)'),
            role: 'body',
            delay: isMobile ? 360 : 480
          },
          {
            element: materials.querySelector('.ns-journey__link'),
            role: 'action',
            delay: isMobile ? 520 : 680
          },
          {
            element: materialItems[0],
            role: 'body',
            delay: isMobile ? 650 : 760
          },
          {
            element: materialItems[1],
            role: 'body',
            delay: isMobile ? 790 : 940
          }
        ]);
      }

      const assurance = document.querySelector('.ns-journey__assurance');
      if (assurance) {
        const assuranceItems = Array.from(assurance.children);
        const assuranceDelays = isMobile ? [0, 90, 210, 340] : [0, 110, 270, 450];
        addSequence(
          assurance,
          assuranceItems.map((element, index) => ({
            element,
            role: 'action',
            delay: assuranceDelays[index] ?? index * 110
          }))
        );
      }

      const pageWrapper = document.querySelector('.page-wrapper');
      const scrollContainer =
        pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 2
          ? pageWrapper
          : null;

      state.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) revealSequence(entry.target);
          });
        },
        {
          root: scrollContainer,
          threshold: 0.08,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      state.sequences.forEach((sequence) => {
        if (sequence !== state.hero) state.observer.observe(sequence);
      });
    };

    const runIntro = () => {
      const root = getRoot();
      if (!root) return;

      const designMode = root.dataset.designMode === 'true' || window.Shopify?.designMode;
      const introEnabled = root.dataset.enableIntro === 'true';
      const introPending = document.documentElement.classList.contains('nx-intro-pending');

      const finish = () => {
        clearIntro();
      };

      const revealHero = () => {
        if (state.hero) window.requestAnimationFrame(() => revealSequence(state.hero));
      };

      const scrollRoot = document.querySelector('.page-wrapper');
      const restoredBelowTop = (scrollRoot?.scrollTop || window.scrollY) > 12;

      if (designMode || !motionIsAllowed() || !introEnabled || !introPending || restoredBelowTop) {
        finish();
        revealHero();
        return;
      }

      try {
        window.sessionStorage.setItem('nexuskin-intro-seen', '1');
      } catch (error) {
        void error;
      }

      const duration = mobileViewport.matches ? 2050 : 2450;
      const heroLead = mobileViewport.matches ? 330 : 400;

      state.heroTimer = window.setTimeout(revealHero, duration - heroLead);
      state.introTimer = window.setTimeout(finish, duration);
    };

    const refresh = () => {
      prepareSequences();
      runIntro();
    };

    window.NexuskinHomeMotion = {
      refresh,
      revealAll
    };

    document.addEventListener('focusin', (event) => {
      const sequence = event.target.closest?.('[data-nx-sequence]');
      if (sequence) revealSequence(sequence);
    });

    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:select', (event) => {
      event.target.querySelectorAll?.('[data-nx-sequence]').forEach(revealSequence);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const sequence = event.target.closest?.('[data-nx-sequence]');
      if (sequence) revealSequence(sequence);
    });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      clearTimers();
      clearIntro();
      revealAll();
    });

    reducedMotion.addEventListener?.('change', refresh);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-product-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('nks-product-story')) return;
  function initialize(root) {
    const controller = new AbortController();
    const listen = (target, name, handler, options = {}) => target.addEventListener(name, handler, {...options, signal: controller.signal});
    // Read the host's visible purchase bar without changing its commerce behavior.
    const cartBar = root.closest('main')?.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar');
    const syncDock = () => {
      const inset = cartBar?.dataset.stuck === 'true'
        ? cartBar.getBoundingClientRect().height + (parseFloat(getComputedStyle(cartBar).bottom) || 0) : 0;
      root.style.setProperty('--nks-dock-inset', `${inset}px`);
    };
    const dockResize = new ResizeObserver(syncDock);
    const dockState = new MutationObserver(syncDock);
    if (cartBar) {
      dockResize.observe(cartBar);
      dockState.observe(cartBar, {attributes:true, attributeFilter:['data-stuck']});
    }
    syncDock();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 990px)');
  const hoverDevice = matchMedia('(hover: hover) and (pointer: fine)');
  const stories = [...root.querySelectorAll('.nks-story')].map(element => ({
    element,
    panel: element.querySelector('.nks-story__panel'),
    content: element.querySelector('.nks-story__content'),
    body: element.querySelector('.nks-story__body'),
    button: element.querySelector('.nks-story__toggle'),
    hovered: false, explicit: null, opened: element.classList.contains('nks-is-open'), rest: 0, height: 0,
    visibleHeight: 0, bodyOffset: 0,
  }));

  function setOpen(story, open) {
    if (story.opened === open) return;
    story.opened = open;
    story.element.classList.toggle('nks-is-open', open);
    story.button.setAttribute('aria-expanded', String(open));
    story.body.setAttribute('aria-hidden', String(!open));
  }

  function measure(story) {
    story.height = story.element.getBoundingClientRect().height;
    const bodyHeight = story.body.getBoundingClientRect().height;
    const line = parseFloat(getComputedStyle(story.body).lineHeight);

    story.bodyOffset = Math.max(0, bodyHeight - (desktop.matches ? line : 0));
    story.visibleHeight = story.content.offsetHeight - story.bodyOffset;
    story.rest = Math.max(0, story.height * .55 - story.visibleHeight);
    story.element.style.setProperty('--nks-body-offset', `${story.bodyOffset}px`);
    story.element.style.setProperty('--nks-pin-rest', `${story.rest}px`);
  }

  function scrollBounds(element) {
    for (let parent = element.parentElement; parent; parent = parent.parentElement) {
      if (!/(auto|scroll)/.test(getComputedStyle(parent).overflowY)) continue;
      if (parent.scrollHeight <= parent.clientHeight) continue;
      const rect = parent.getBoundingClientRect();
      return {top: rect.top + parent.clientTop, height: parent.clientHeight};
    }
    return {top: 0, height: window.innerHeight};
  }

  let frame = 0;
  function paint() {
    frame = 0;
    for (const story of stories) {
      const viewport = scrollBounds(story.element);
      const bottom = story.panel.getBoundingClientRect().bottom;

      const contentCenter = bottom - story.content.offsetHeight / 2 + story.bodyOffset;
      const scrollOpen = desktop.matches && contentCenter < viewport.top + viewport.height * .45;
      story.element.classList.toggle('nks-is-background', !desktop.matches && contentCenter < viewport.top + viewport.height * .45);
      const open = story.explicit === null ? (scrollOpen || story.hovered) : story.explicit;
      setOpen(story, open);
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(paint);
  }

  for (const story of stories) {
    listen(story.button, 'click', () => {
      story.explicit = !story.opened;
      setOpen(story, story.explicit);
      schedule();
    });
    listen(story.panel, 'pointerenter', () => {
      if (!desktop.matches || !hoverDevice.matches) return;
      story.hovered = true;
      if (story.explicit !== false) setOpen(story, true);
    });
    listen(story.panel, 'pointerleave', () => {
      story.hovered = false;

      schedule();
    });
    listen(story.panel, 'keydown', event => {
      if (event.key !== 'Escape') return;
      story.explicit = false;
      setOpen(story, false);
      story.button.focus({preventScroll: true});
    });
  }

  const resize = new ResizeObserver(() => {
    for (const story of stories) measure(story);
    schedule();
  });
  for (const story of stories) {
    resize.observe(story.element);
    resize.observe(story.content);
    measure(story);
  }
  listen(document, 'scroll', schedule, {passive: true, capture: true});
  listen(window, 'resize', schedule, {passive: true});
  listen(desktop, 'change', () => {
    for (const story of stories) { story.hovered = false; measure(story); }
    schedule();
  });
  document.fonts.ready.then(() => { if (controller.signal.aborted) return; stories.forEach(measure); schedule(); });
  listen(reducedMotion, 'change', schedule);

  paint();
  for (const story of stories) {
    story.content.getBoundingClientRect();
    story.element.classList.add('nks-is-ready');
  }

  const dialog = root.querySelector('.nks-size-dialog');
  let dialogOpener;
  root.querySelectorAll('[data-open-size]').forEach(button => listen(button, 'click', () => {
    dialogOpener = button;
    dialog.showModal();
  }));
  dialog.querySelectorAll('.nks-dialog-close,.nks-dialog-done').forEach(button => listen(button, 'click', () => dialog.close()));
  listen(dialog, 'click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  listen(dialog, 'close', () => dialogOpener?.focus({preventScroll: true}));

  root.querySelectorAll('[data-unit]').forEach(button => listen(button, 'click', () => {
    const unit = button.dataset.unit;
    root.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelector('[data-unit-label]').textContent = root.dataset.unitsLabel.replace('__UNIT__', unit);
    root.querySelectorAll('[data-inches]').forEach(cell => {
      const inches = Number(cell.dataset.inches);
      cell.textContent = unit === 'cm' ? (inches * 2.54).toFixed(1) : String(inches);
    });
  }));

  const video = root.querySelector('.nks-newsletter__video');
  const pauseButton = root.querySelector('.nks-newsletter__pause');
  let userPaused = reducedMotion.matches;
  const syncPause = () => {
    pauseButton.setAttribute('aria-label', video.paused ? root.dataset.playLabel : root.dataset.pauseLabel);
    pauseButton.firstElementChild.textContent = video.paused ? '▷' : 'Ⅱ';
  };
  const visibility = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && !userPaused && !reducedMotion.matches) video.play().catch(syncPause);
      else video.pause();
    }
  }, {rootMargin: '200px'});
  visibility.observe(video);
  listen(pauseButton, 'click', () => {
    userPaused = !video.paused;
    if (video.paused) video.play().catch(syncPause);
    else video.pause();
  });
  listen(video, 'play', syncPause);
  listen(video, 'pause', syncPause);
  if (reducedMotion.matches) {video.pause();video.removeAttribute('autoplay');}
  listen(reducedMotion, 'change', () => {if (reducedMotion.matches) {userPaused = true;video.pause();}});
  syncPause();

  const form = root.querySelector('.nks-newsletter__form');
  listen(form, 'submit', event => {
    event.preventDefault();
    const email = form.elements.email;
    const status = root.querySelector('.nks-newsletter__status');
    if (!email.validity.valid) {
      status.textContent = root.dataset.invalidEmail;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    email.removeAttribute('aria-invalid');
    status.textContent = root.dataset.signupUnavailable;
  });

    return () => { controller.abort(); resize.disconnect(); dockResize.disconnect(); dockState.disconnect(); visibility.disconnect(); cancelAnimationFrame(frame); video.pause(); };
  }
  customElements.define('nks-product-story', class extends HTMLElement {
    connectedCallback() {
      this.pending = requestAnimationFrame(() => { this.cleanup?.(); this.cleanup = initialize(this); });
    }
    disconnectedCallback() { cancelAnimationFrame(this.pending); this.cleanup?.(); this.cleanup = null; }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
